import { render } from "./ChatInputArea.vue?vue&type=template&id=4c9295f5&scoped=true"
import script from "./_ChatInputArea.js?vue&type=script&lang=js"
export * from "./_ChatInputArea.js?vue&type=script&lang=js"

import "./_ChatInputArea.less?vue&type=style&index=0&id=4c9295f5&lang=less&scoped=true"

import exportComponent from "/home/aichat/aichat-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c9295f5"]])

export default __exports__